<style lang="scss" scoped>
.resources-transfer {
}

.left-table {
  width: 400px;
  display: inline-block;
  vertical-align: middle;
}

.right-table {
  width: 400px;
  display: inline-block;
  vertical-align: top;
}
.transfer-action {
  display: inline-block;
  vertical-align: middle;
  padding: 15px;
}
</style>
<template>
  <div class="resources-transfer">
    <el-row :gutter="10" type="flex" align='middle' justify="center">
      <el-col :span="11">

        <l-table :data="left_data" v-loading="loading" height="400" @selection-change="leftSelect">
          <el-table-column fixed type="selection" width="40" align="center" :selectable="(row,index)=>!row._disabled">
          </el-table-column>
          <el-table-column prop="question" label="试题名称" min-width="100">
          </el-table-column>
          <el-table-column prop="code" label="试题编号" min-width="100">
          </el-table-column>
          <el-table-column prop="question_type" label="试题分类" min-width="100">
          </el-table-column>
        </l-table>
      </el-col>
      <el-col :span="2">
        <div style="text-align:center">
          <div>
            <el-button type="primary" icon="el-icon-arrow-right" size="mini" :disabled="!canAddToright" @click="addToRight"></el-button>
          </div>
          <div style="margin-top:10px">
            <el-button type="primary" icon="el-icon-arrow-left" size="mini" :disabled="right_select_data.length==0" @click="delRightData"></el-button>
          </div>
        </div>
      </el-col>
      <el-col :span="11">
        <div class="l-simple-table-toolbar">

        </div>
        <l-table :data="right_data" height="400" @selection-change="rightSelect">
          <el-table-column fixed type="selection" width="40" align="center">
          </el-table-column>
          <el-table-column prop="question" label="试题名称" min-width="100">
          </el-table-column>
          <el-table-column prop="code" label="试题编号" min-width="100">
          </el-table-column>
          <el-table-column prop="question_type" label="试题分类" min-width="100">
          </el-table-column>
        </l-table>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { unionBy } from "lodash";
// import { TYPE_NAMES } from "@/common/constants/resources";
// import Edit from "@/views/resources/Edit";
export default {
  name: "l-permission-resources-transfer",
  // components: {
  //   [Edit.name]: Edit,
  // },
  props: {
    permissionId: {
      type: [Number, String],
      default: "",
    },
    material_stock_id: {
        type: [Number, String],
        default: "",
    },
    useType: {
      type: Number,
      default: 1,
    },
  },

  data() {
    return {
      page: 1,
      page_size: 30,
      left_data: [],
      left_select_data: [],
      right_select_data: [],
      right_data: [],
      count: 0,
      loading: false,
      first_req: true,

      s_left_identify: "",
      s_right_identify: "",

      add_visible: false,

      search_data: {
        identify: "",
      },

      rel_search_data: {},

      // TYPE_NAMES: TYPE_NAMES,
    };
  },

  watch: {
    //监听右侧数据变化，调用回调函数
    right_data() {
      //获取选中的key
      const target_keys = this.right_data.map((item) => {
        return item.id;
      });
      this.$emit("on-change", target_keys);
    },
  },

  computed: {
    //是否可向右侧添加数据
    canAddToright() {
      if (this.left_select_data.length == 0) {
        return false;
      }

      //判断所有选中项是否都是disabled状态
      let is_all_disabled = true;
      this.left_data.forEach((item) => {
        const index = this.left_select_data.findIndex((select_item) => {
          return select_item.id == item.id;
        });

        if (index != -1 && item._disabled !== true) {
          is_all_disabled = false;
        }
      });

      return !is_all_disabled;
    },

    //右侧数据
    getRightData() {
      if (this.s_right_identify !== "") {
        const result = this.right_data.filter((item) => {
          return item.identify.indexOf(this.s_right_identify) !== -1;
        });

        return result;
      }

      return this.right_data;
    },
  },

  mounted() {
    this.getData();
  },

  methods: {
    //获取源数据
    getData() {
        console.log('itembanktransfer:'+this.$props.material_stock_id);
      this.loading = true;
      this.$_invoke("trainManage_getItemBankList", {
        page: this.page,
        page_size: this.page_size,
        identify: this.s_left_identify,
        material_stock_id: this.first_req ? this.$props.material_stock_id : 0,
        ...this.rel_search_data,
      })
        .then((ret) => {
          //清空选中项
          this.left_select_data = [];
          this.left_data = ret.data;
          this.count = ret.count;

          //首次请求，初始化右侧数据
          if (this.first_req) {
            this.right_data = ret.h_data;
            this.first_req = false;
          }

          //给选中的数据添加禁止选中
          this.left_data = this.left_data.map((item) => {
            const index = this.right_data.findIndex((select_item) => {
              return item.id == select_item.id;
            });

            if (index != -1) {
              item._disabled = true;
              item._checked = true;
            }
            return item;
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getData();
    },

    //页码变化
    pageChange(page) {
      this.page = page;
      this.getData();
    },

    //监听左表的选中
    leftSelect(selection) {
      this.left_select_data = selection;
    },

    //点击往右表中添加选中数据
    addToRight() {
      //将左侧选中数据先移除disabled和checked属性
      const left_select_data = this.left_select_data.map((item) => {
        delete item._disabled;
        delete item._checked;
        return item;
      });

      this.right_data = unionBy(this.right_data, left_select_data, "id");
      console.log(this.right_data);
      //给选中的数据添加禁止选中
      this.left_data = this.left_data.map((item) => {
        const index = left_select_data.findIndex((select_item) => {
          return item.id == select_item.id;
        });

        if (index != -1) {
          item._disabled = true;
          item._checked = true;
        }
        return item;
      });
    },

    //监听右表的选中
    rightSelect(selection) {
      this.right_select_data = selection;
      //将对应数据设置为选中
      this.right_data.map((item) => {
        const index = this.right_select_data.findIndex((select_item) => {
          return item.id == select_item.id;
        });

        if (index != -1) {
          item._checked = true;
        } else {
          delete item._checked;
        }
        return item;
      });
    },

    //点击删除右表中的数据
    delRightData() {
      const curr_right_select_data = this.right_select_data.concat([]);
      //将右侧选中的数据删除
      this.right_data = this.right_data.filter((item) => {
        const index = curr_right_select_data.findIndex((select_item) => {
          return item.id == select_item.id;
        });
        return index == -1 ? true : false;
      });

      //将左侧选中项移除
      this.left_select_data = this.left_select_data.filter((item) => {
        const index = curr_right_select_data.findIndex((select_item) => {
          return item.id == select_item.id;
        });
        return index == -1 ? true : false;
      });

      //将左侧数据对应项设置为未选中
      this.left_data = this.left_data.map((item) => {
        const index = curr_right_select_data.findIndex((select_item) => {
          return item.id == select_item.id;
        });

        if (index != -1) {
          item._disabled = false;
          item._checked = false;
        }
        return item;
      });

      //清空选择
      this.right_select_data = [];
    },

    //点击左侧搜索
    onLeftSearch(value) {
      this.s_left_identify = value;
      this.getData();
    },

    //点击右侧搜索
    onRightSearch(value) {
      this.s_right_identify = value;
    },

    //显示添加资源的弹窗
    showAdd() {
      this.add_visible = true;
    },

    //添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getData();
    },
  },
};
</script>